import React from 'react'
import { observer } from 'mobx-react'
import useStores from '@stores/useStores'
import Action from '@ui/ActionButton'

const Actions = ({ onBack, onSkip, onNext }) => {
  const { surveyState, appState } = useStores()
  const { language_code, currentQuestion } = surveyState
  const { right_to_left } = appState.getLanguageByCode(language_code)
  const onNextEnabled = currentQuestion.isValid

  const back = onBack && (
    <Action
      onClick={onBack}
      content='Previous'
      className='back-btn'
      direction={right_to_left ? 'right' : 'left'}
    />
  )

  const skip = onSkip && (
    <Action
      onClick={onSkip}
      content='Skip'
      className='skip-btn'
      direction={right_to_left ? 'left' : 'right'}
    />
  )

  const next = (
    <Action
      disabled={!onNextEnabled}
      primary
      onClick={onNext}
      content={surveyState.continueButton}
      direction={right_to_left ? 'left' : 'right'}
    />
  )

  return (
    <div className='button-actions flex no-wrap'>
      {back}
      {skip}
      {next}
    </div>
  )
}
export default observer(Actions)
